// version : 0.0.2
// LastEdit : AGALYA
// MODFIED DATE: 28-02-2026
// Last ADD : INITIAL STATE CHANGED AND UNWANTED ESLINT DISABLED

import AuditingToolReportActionTypes from './auditing-tool-report.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	getAuditingToolReportListResponse: null,
	getAuditingToolReportListArr: [],
};

const auditingToolReportReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** *********************  START GET AUDITING TOOL REPORT DETAILS  ******************** */
		case AuditingToolReportActionTypes.GET_AUDITING_TOOL_REPORT_LIST_SUCCESS:
			return {
				...state,
				getAuditingToolReportListResponse: action.payload,
				getAuditingToolReportListArr: docodeHexResponse(
					action.payload,
					'GetAuditingToolKey',
				),
			};

		case AuditingToolReportActionTypes.GET_AUDITING_TOOL_REPORT_LIST_FAILURE:
			return {
				...state,
				getAuditingToolReportListResponse: action.payload,
				getAuditingToolReportListArr: [],
			};

		case AuditingToolReportActionTypes.GET_AUDITING_TOOL_REPORT_LIST_RESPONSE_CHANGED:
			return {
				...state,
				getAuditingToolReportListResponse: null,
			};
		/** *********************  END GET AUDITING TOOL REPORT DETAILS ******************** */

		default:
			return state;
	}
};

export default auditingToolReportReducer;
